import { Utils } from "../../../../../../../services/utils.service";
import { DataCollection } from "../../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { TransportData } from "../../../../../../infrastructure/transportdata";

export class BcmPostMasterFetchRequest {
    public static readonly FetchRequestType: string = "bcm_post_fetch_request";
bcm_post_master_ids: number[] = [];
zone_ids: number[] = [];
district_ids: number[] = [];
block_ids: number[] = [];
phc_ids: number[] = [];

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, BcmPostMasterFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);
        return td;
    }
}

export class BCMPostNameFetchRequest {
    public static readonly FetchRequestType: string = "bcm_post_name_fetch_request";
    
    bcm_post_master_ids: number[] = [];
 zone_ids: number[] = [];
district_ids: number[] = [];
block_ids: number[] = [];
    bcm_post_ids:number[] = [];
    phc_ids: number[] = [];

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, BCMPostNameFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

